export { default } from './CollaborateLogos';
